import ContactPageContent from '../components/contactus/ContactusPageContent';

const ContactPage=()=>{
    return <ContactPageContent/>
};

export default ContactPage;